'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('babel-polyfill');

var environment = {
  development: {
    isProduction: false
  },
  production: {
    isProduction: true
  }
}[process.env.NODE_ENV || 'development'];

module.exports = (0, _assign2.default)({
  host: process.env.HOST || 'localhost',
  port: process.env.PORT,
  apiHost: process.env.APIHOST || 'localhost',
  apiPort: process.env.APIPORT,
  //elasticsearch: '192.168.100.1:9200',
  //elasticsearch: 'localhost:9200',
  elasticsearch: '192.168.2.204:9200',
  //elasticsearch: '192.168.2.20:9200',
  mongo: {
    hosts: [{ host: '192.168.100.1', port: 27017 }]
  },
  mongoCatalog: 'agama2000Prod', // katalog musi byt zvlast - viz cteni v mongo.js
  appSettings: {
    minSearchTextLength: 3, // i s pridanou hvezdickou na konci
    allowMemoryDumping: true,
    memoryDumpingInterval: 30000,
    dumpMemorySnapshots: true,
    googleAuthClientId: '280466207305-cfa12qqpekqfkgi21c9rmm7p4afte4ev.apps.googleusercontent.com',
    googleAuthClientSecret: 'dwo3LkU7ZrWh9fiVBIqoFvQ1',
    facebookAuthClientId: '226342524229749'
  },
  app: {
    night: false,
    version: '2.0.9',
    codeName: 'Alpha5 [25.2.2017]',
    title: 'Agama2000',
    menuTitle: 'Agama2000 - 2017',
    description: 'Zpěvník Agama',
    head: {
      titleTemplate: 'Agama2000: %s',
      meta: [{ name: 'description', itemProp: 'description', content: 'Zpěvnik pro kytaru s akordy. Transponovaní. Songbook, lyrics with chords for guitar.' }, { name: 'keywords', itemProp: 'keywords', content: 'hudba, zpěvník, kytara, akordy, texty písní' }, { charset: 'utf-8' }, { property: 'og:site_name', content: 'Agama2000' }, { property: 'og:image', content: 'https://Agama2000.com/logo.png' }, { property: 'og:image:width', content: '200' }, { property: 'og:image:height', content: '200' }, { property: 'og:locale', content: 'cs_CZ' }, { property: 'og:title', content: 'Agama2000 Zpěvník - Texty písní s akordy na kytaru' }, { property: 'og:description', content: 'Zpěvnik pro kytaru s akordy. Texty písní s akordy, transponovaní. Songbook, lyrics with chords for guitar.' }, { property: 'og:site', itemProp: 'name', content: 'agama2000' }, { property: 'og:creator', content: '@agama2000' }, { property: 'og:url', content: 'agama2000.com' }, { property: 'fb:app_id', content: '226342524229749' }, { property: 'google-site-verification', content: 'qzAdCsxEEjNoFrpoxhRdYad5uaqfITeSthIXlkn5xOE' }, { property: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no' }, { property: 'fb:app_id', content: '226342524229749' }]
    }
  }

}, environment);


//////////////////
// WEBPACK FOOTER
// ./src/config.js
// module id = 119
// module chunks = 0